"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const core_1 = require("@angular/core");
const material_1 = require("@angular/material");
const router_1 = require("@angular/router");
const BaseComponent_1 = require("@src/app/commons/BaseComponent");
const Constants_1 = require("@src/app/commons/Constants");
const plugin_controller_1 = require("@src/app/commons/plugins/plugin-controller");
const scene_controller_service_1 = require("@src/app/service/controllers/scene-controller.service");
const plugin_manager_service_1 = require("@src/app/service/plugin-manager.service");
const application_events_service_1 = require("../../events/application-events.service");
const ui_manager_service_1 = require("../ui-manager.service");
class XsCameraControllerComponent extends BaseComponent_1.BaseComponent {
    constructor(
    // the three BaseComponent services
    router, snackBar, dialog, 
    // others we need
    uiManager, sceneController, applicationEvents, pluginManager) {
        super(router, snackBar, dialog);
        this.router = router;
        this.snackBar = snackBar;
        this.dialog = dialog;
        this.uiManager = uiManager;
        this.sceneController = sceneController;
        this.applicationEvents = applicationEvents;
        this.pluginManager = pluginManager;
        this.debug = false;
        // show the component?
        this.show = false;
        // what plugin is in action
        this.plugin = null;
        // What's the context? Who's calling the shots?
        this.context = this;
        // id for the popover panel itself
        this.id = null;
        this.items = [];
        if (this.debug) {
            console.log('CameraControllerCOMPONENT %c [dunnoyet] %c CONSTRUCT', Constants_1.Constants._pink, Constants_1.Constants._pink);
        }
    }
    // look for changes to the @input variables
    ngOnChanges() {
        if (this.debug) {
            console.log('CameraCtrl %c [dunnoyet] %c ngChanges() ', Constants_1.Constants._pink, Constants_1.Constants._pink, this.pluginController, this.controller);
        }
        if (this.pluginController) {
            this.pluginController.injectComponent(this);
        }
        // this controller is the popover controller (works as a bridge between the popower 
        // component and where it works from, for example layers.comp or map.comp, etc.)
        if (this.controller) {
            this.controller.injectComponent(this);
            // different contexts bring different plugin controllers
            if (this.controller.pluginController) {
                this.pluginController = this.controller.pluginController;
            }
        }
    }
    init() {
        // just use the component UUID as the popover id
        this.id = this.__ID.instance;
        if (this.debug) {
            console.log('CameraCtrl %c ' + this.__ID.instance + ' %c COMPONENT INIT', Constants_1.Constants._pink, Constants_1.Constants._pink);
        }
    }
    open() {
        this.show = true;
    }
    close() {
        this.show = false;
    }
    add(i) {
        this.capture(i);
        // console.log('#add', i );
    }
    capture(i) {
        let category = i['category'];
        let item = i.data && i.data.obj ? i.data.obj : { error: 'no such item', category, i };
        item['cameraPosition'] = this.sceneController.getCamera();
        i.data.global.camera = item['cameraPosition'];
        // console.log('#capture',category, i, item, item['cameraPosition'] );
        setTimeout(() => { i.captured = true; }, 400);
        setTimeout(() => { i.captured = false; }, 3000);
        item.saveObservable().subscribe();
    }
    flyTo(i) {
        let category = i['category'];
        let item = i.data && i.data.obj ? i.data.obj : { error: 'no such item', category, i };
        // console.log('#flyto', category, i, item, item['cameraPosition'] );
        if (item['cameraPosition']) {
            this.sceneController.flyToCamera(item['cameraPosition']);
        }
    }
    delete(i) {
        let category = i['category'];
        let item = i.data && i.data.obj ? i.data.obj : { error: 'no such item', category, i };
        item['cameraPosition'] = null;
        delete item['cameraPosition'];
        i.data.global.camera = null;
        // this.sceneController.checkForCameraBookmarks(category,item);
        // console.log('#delete',category, i, item, item['cameraPosition'] );
        item.saveObservable().subscribe();
    }
}
exports.XsCameraControllerComponent = XsCameraControllerComponent;
